import { ApiService } from '../ApiService';
import type { Account } from '../../../types/accounting';
import type { AccountSearchParams } from '../../../types/filters';
import type { PaginatedResponse } from '../types';

export const accountsApi = {
  getAll: (params?: AccountSearchParams) => 
    ApiService.get<PaginatedResponse<Account>>('/accounts', params),

  getById: (id: string) => 
    ApiService.get<Account>(`/accounts/${id}`),

  create: (account: Partial<Account>) => 
    ApiService.post<Account>('/accounts', account),

  update: (id: string, account: Partial<Account>) => 
    ApiService.put<Account>(`/accounts/${id}`, account),

  delete: (id: string) => 
    ApiService.delete<void>(`/accounts/${id}`),

  createBatch: (accounts: Partial<Account>[]) => 
    ApiService.post<Account[]>('/accounts/batch', { accounts }),

  search: (query: string, params?: { limit?: number; types?: string[] }) =>
    ApiService.get<Account[]>('/accounts/search', { query, ...params })
};